import script from "./SelectField.vue?vue&type=script&lang=ts&setup=true"
export * from "./SelectField.vue?vue&type=script&lang=ts&setup=true"

import "./SelectField.vue?vue&type=style&index=0&id=4a5300c2&lang=scss"

const __exports__ = script;

export default __exports__